import { render, staticRenderFns } from "./StatComplete.vue?vue&type=template&id=d8bed5a4&scoped=true&"
import script from "./StatComplete.vue?vue&type=script&lang=js&"
export * from "./StatComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bed5a4",
  null
  
)

export default component.exports